import styles from "./Banner.module.scss";
import BannerImage from "../../../static/images/scree-shots.png";
import { Button } from "../../primary";

const Banner = ({ ne1Wms, loading, onClick }) => {
  return (
    <section className={styles.banner}>
      <div className={styles.content}>
        <h1>Wound classification app</h1>

        <p>Digital wound care beyond measure™: Accurately classify wounds with the NE1® Wound Management System.</p>

        {ne1Wms === 1 ? (
          <Button type="button" className={styles.banner_btn} onClick={onClick}>
            Launch NE1
            <span style={{ marginBottom: 2 }}>
              <svg width="32" height="16" viewBox="0 0 32 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M1 8H29M29 8L23 2M29 8L23 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </Button>
        ) : (
          <Button type="button" className={styles.banner_btn} onClick={onClick}>
            {loading && <div className={styles.custom_spinner} data-testid="spinner"></div>} Request a demo
          </Button>
        )}
      </div>

      <div className={styles.imageSection}>
        <img src={BannerImage} alt="Skin Health" />
      </div>
    </section>
  );
};

export default Banner;
